import { IScheduleEntry } from '@app-types/websocket/schedule.types';
import { IHandoverDayData, IHandoverData } from './calendar.types';

export const daysInMonth = (year: number, month: number) => {
    return ;
}

export const paddingDays = (month: number, year: number, localization: "se" | "en") => {
    const startingDay = new Date(year, month, 1).getDay();
    if (localization === "en") {
        return startingDay;
    } else {
        if (startingDay === 0) { return 6; }
        return startingDay - 1;
    }
}

export const weeksMonth = (month: number, year: number, localization: "se" | "en") => {
    return Math.ceil((new Date(year, month+1, 0,0,0,1).getDate() + paddingDays(month,year,localization)) / 7);
}

const addHandoverInTimeOrder = (handovers: IHandoverData[], handover: IHandoverData) => {
    let insertAt = handovers.length;
    while (insertAt > 0 && handovers[insertAt - 1].time > handover.time) {
        insertAt -= 1;
    }
    handovers.splice(insertAt, 0, handover);
}

export const generateHandoverData = (entries:{[key: string]: IScheduleEntry}, parent:number, start:number, end:number):IHandoverDayData => {
    let hasWholeDay:boolean = false;
    let hasMorning:boolean = false;
    let hasNight:boolean= false;
    let hasVisitation:boolean = false;
    let writeName = false;
    const handovers:IHandoverData[] = [];

    for (const key of Object.keys(entries)) {
        const scheduleEntry: IScheduleEntry = entries[key];
        if (scheduleEntry.startTime < end && scheduleEntry.startTime > start) {
            if (scheduleEntry.endTime < end && scheduleEntry.endTime > start) { // this entry starts and ends this day
                hasVisitation = true;
                addHandoverInTimeOrder(handovers,
                    {time:scheduleEntry.startTime,atSchool:scheduleEntry.startAtSchool,location:scheduleEntry.startLoc,pickup:true});
                addHandoverInTimeOrder(handovers,
                    {time:scheduleEntry.endTime,atSchool:scheduleEntry.endAtSchool,location:scheduleEntry.endLoc,pickup:false});
            } else { // this entry starts this day
                hasNight = true;
                addHandoverInTimeOrder(handovers,
                    {time:scheduleEntry.startTime,atSchool:scheduleEntry.startAtSchool,location:scheduleEntry.startLoc,pickup:true});
            }
        } else if (scheduleEntry.endTime < end && scheduleEntry.endTime > start) { // this entry ends this day
            hasMorning = true;
            addHandoverInTimeOrder(handovers,
                {time:scheduleEntry.endTime,atSchool:scheduleEntry.endAtSchool,location:scheduleEntry.endLoc,pickup:false});
        } else if (scheduleEntry.endTime > end && scheduleEntry.startTime < start) { // this entry starts before and ends after this day
            hasWholeDay = true;
            hasMorning = true;
            hasNight = true;
            if (scheduleEntry.startTime > start-(1000*60*60*24)) {
                writeName = true;
            }
        }
    }

    return { hasWholeDay, hasMorning, hasNight, hasVisitation, handovers, parent, writeName }
}

// The handovers a day lists as text rows under a schedule's custody bar: only a visitation day has them
export const visitationHandovers = (dataA:IHandoverDayData, dataB:IHandoverDayData):IHandoverData[] => {
    if (dataA.hasWholeDay || dataB.hasWholeDay) { return []; }
    if (dataA.hasVisitation) { return dataA.handovers; }
    if (dataB.hasVisitation) { return dataB.handovers; }
    return [];
}



// WEBPACK FOOTER //
// ./src/components/calendar2/helper.ts